var React = require('react');

function MaskClientCheckInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"13","width":"177","height":"47","rx":"9","fill":"white","key":0}),React.createElement("path",{"d":"M200.5 22.5C194.5 22.5 191 32.1667 190 37L177.5 30L185.5 11.5L198.5 6C201.667 11.5 206.5 22.5 200.5 22.5Z","fill":"white","key":1}),React.createElement("path",{"d":"M2.85498 22.5C8.85498 22.5 12.355 32.1667 13.355 37L25.855 30L17.855 11.5L4.85498 6C1.68831 11.5 -3.14502 22.5 2.85498 22.5Z","fill":"white","key":2})]);
}

MaskClientCheckInline.defaultProps = {"width":"204","height":"47","viewBox":"0 0 204 47","fill":"none"};

module.exports = MaskClientCheckInline;

MaskClientCheckInline.default = MaskClientCheckInline;
